module.exports = __webpack_public_path__ + "media/music/d434438e5d193118e4aad3a846e1c7ba.mp3";